<script>
  import tinycolor from 'tinycolor2';
  import TextInput from 'components/TextInput/TextInput';
  import draft from 'stores/Draft';
  import ui from 'stores/UI';
  import * as draftUtil from 'util/DraftUtil';
  import { t } from 'precompile-intl-runtime';
  import { onMount, onDestroy } from 'svelte';
  import { colorPickerStore } from '../../ColorPickerDialog/ColorPickerStore.js';

  window.tinycolor = tinycolor;

  let colors = [];
  $: {
    $draft.yarn.forEach((y) => {
      colors[y.id] = tinycolor.fromRatio(y.color);
    });
  }
  //let color = { r: 1.0, g: 0.0, b: 0.0 };
  //let newYarnColor = color;
  let colorListener;

  $: yarnUnderModification = $ui.selectedColor;
  $: selectedYarn = $draft.yarn.find((y) => yarnUnderModification === y.id);
  $: selectedColor = tinycolor.fromRatio(selectedYarn?.color);
  let showImport = false;
  let importData;

  function focus(elm) {
    elm.focus();
  }

  onMount(() => {
    colorListener = colorPickerStore.onColorChange((color) => {
      if (yarnUnderModification !== -1) {
        draft.update((temp) => {
          temp.yarn.find((a) => a.id === yarnUnderModification).color = color;
        });
      }
    });
  });

  onDestroy(() => {
    colorPickerStore.removeListener(colorListener);
  });

  function createNewYarn(event) {
    event.preventDefault();

    let id = $draft.yarn.map((a) => a.id).reduce((a, b) => Math.max(a, b)) + 1;
    draft.update((temp) => {
      draftUtil.newYarn(temp, {
        name: 'Yarn',
        color: { r: 1.0, g: 1.0, b: 1.0 },
      });
    });
    ui.update((temp) => {
      temp.selectedColor = id;
    });
  }

  function selectYarnForModification(event, i) {
    ui.update((temp) => {
      temp.selectedColor = i;
    });
  }

  function changeName(newName, yarnId) {
    draft.update((temp) => {
      temp.yarn.find((a) => a.id === yarnId).name = newName;
    });
  }

  function deleteColor(id) {
    ui.update((temp) => {
      let indexOf = $draft.yarn.findIndex((a) => a.id === id);
      if (indexOf == 0) {
        indexOf = 2;
      }
      temp.selectedColor = $draft.yarn[indexOf - 1].id;
    });
    draft.update((temp) => {
      draftUtil.removeYarn(temp, id);
    });
  }

  function showColorPicker(event) {
    event.preventDefault();
    colorPickerStore.showColorPicker(
      event.pageX,
      event.pageY,
      selectedYarn.color
    );
  }

  /*
   CSV
397367,63ccca,5da399,42858c,35393c

   Array
["397367","63ccca","5da399","42858c","35393c"]

 Object
{"Hookers Green":"397367","Medium Turquoise":"63ccca","Polished Pine":"5da399","Steel Teal":"42858c","Onyx":"35393c"}

 Extended Array 
[{"name":"Hookers Green","hex":"397367","rgb":[57,115,103],"cmyk":[50,0,10,55],"hsb":[168,50,45],"hsl":[168,34,34],"lab":[44,-22,1]},{"name":"Medium Turquoise","hex":"63ccca","rgb":[99,204,202],"cmyk":[51,0,1,20],"hsb":[179,51,80],"hsl":[179,51,59],"lab":[76,-31,-8]},{"name":"Polished Pine","hex":"5da399","rgb":[93,163,153],"cmyk":[43,0,6,36],"hsb":[171,43,64],"hsl":[171,28,50],"lab":[62,-25,-2]},{"name":"Steel Teal","hex":"42858c","rgb":[66,133,140],"cmyk":[53,5,0,45],"hsb":[186,53,55],"hsl":[186,36,40],"lab":[52,-19,-10]},{"name":"Onyx","hex":"35393c","rgb":[53,57,60],"cmyk":[12,5,0,76],"hsb":[206,12,24],"hsl":[206,6,22],"lab":[24,-1,-2]}]
  */

  function toRatio(color) {
    return {
      r: color.r / 255,
      g: color.g / 255,
      b: color.b / 255,
    };
  }

  function addImportedColors(event) {
    event.preventDefault();
    console.log('Please import ' + importData);
    let str = importData.trim();
    let yarns = [];
    try {
      let json = JSON.parse(str);
      if (json instanceof Array) {
        if (json[0] instanceof Object) {
          //It's an extended array
          for (let item of json) {
            let color = tinycolor(item.hex);
            if (!color.isValid()) {
              throw new Error('Invalid color', item);
            }
            yarns.push({
              name: item.name,
              color: toRatio(color.toRgb()),
            });
          }
        } else {
          //It's array of strings
          for (let item of json) {
            let color = tinycolor(item);
            if (!color.isValid()) {
              throw new Error('Invalid color', item);
            }
            yarns.push({
              name: 'Yarn',
              color: toRatio(color.toRgb()),
            });
          }
        }
      } else {
        //It's an object of key-values
        for (let item of Object.entries(json)) {
          let color = tinycolor(item[1]);
          if (!color.isValid()) {
            throw new Error('Invalid color', item);
          }
          yarns.push({
            name: item[0],
            color: toRatio(color.toRgb()),
          });
        }
      }
    } catch (e) {
      //Either it is an csv or a junk string
      let arr = importData.split(',');
      for (let item of arr) {
        let color = tinycolor(item);
        if (!color.isValid()) {
          //It's a junk string
          //Show error
          console.error('Unable to import colors from string ' + importData, e);
          showImport = false;
          return;
        }
        yarns.push({
          name: 'Yarn',
          color: toRatio(color.toRgb()),
        });
      }
    }

    if (yarns.length > 0) {
      draft.update((temp) => {
        for (let y of yarns) {
          draftUtil.newYarn(temp, y);
        }
      });
    }

    importData = '';
    showImport = false;
  }
</script>

<div class="yarn-settings">
  <div class="container">
    <div class="add-or-remove">
      <button class="add" on:click={createNewYarn}>+</button>
      <button
        disabled={$draft.yarn.length <= 1 || undefined}
        class="remove"
        on:click={() => deleteColor(yarnUnderModification)}>-</button
      >
    </div>
    <div class="yarns">
      {#each $draft.yarn as yarn}
        <button
          class:selected={yarnUnderModification === yarn.id}
          class="yarn"
          on:click={(e) => selectYarnForModification(e, yarn.id)}
        >
          <div
            class="color"
            style={`background-color: ${colors[yarn.id].toHexString()};`}
          />
          <div class="name">{yarn.name}</div>
        </button>
      {/each}
    </div>
  </div>
  {#if !showImport}
    <button on:click={() => (showImport = true)}>Paste</button>
  {:else}
    <form on:submit={addImportedColors}>
      <input
        type="text"
        bind:value={importData}
        on:blur={() => (showImport = false)}
        use:focus
      />
    </form>
  {/if}
  {#if yarnUnderModification !== -1}
    <div>
      <TextInput
        label={$t('page.yarn_settings.name')}
        value={selectedYarn?.name}
        on:input={(e) => changeName(e.target.value, yarnUnderModification)}
      />
      <div>
        <label for="newYarnColor">{$t('terms.color')}</label>
        <button
          class="yarn-color-change"
          style={`background-color: ${selectedColor.toHexString()};`}
          on:click={showColorPicker}
        />
      </div>
    </div>
  {/if}
</div>

<style>
  .container {
    display: flex;
    align-items: start;
  }

  .add-or-remove {
    margin-right: 5px;
    text-align: center;
    background-color: var(--color-2);
    padding: 4px;
    color: white;
    border-radius: 4px;
    border: 1px solid #535353;

    display: flex;
    flex-direction: column;
  }

  .add-or-remove button {
    color: var(--color-1);
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    width: 2em;
    height: 2em;
  }

  .add-or-remove button:disabled {
    color: gray;
  }

  .yarn {
    background: none;
    border: none;

    display: flex;
    color: var(--color-1);
    margin: 4px;
    padding: 4px 0;
    border-radius: 4px;
  }

  .yarn.selected {
    color: var(--color-2);
    background-color: var(--color-1);
  }

  .yarn:not(:first-child):before {
  }

  .name {
    margin-left: 4px;
  }

  .color {
    margin-left: 4px;
    width: 1em;
    height: 1em;
    border: 1px solid var(--color-2);
  }

  .yarns {
    background-color: var(--color-2);
    min-width: 10em;
    border-radius: 4px;
    border: 1px solid #535353;

    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .yarn-color-change {
    width: 100%;
    margin: 0;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid var(--color-2);
  }
</style>
